import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { initVersionGuard } from './utils/versionGuard';


// Silence noisy dev logs in production; keep console.error/warn for real diagnostics.
if (process.env.NODE_ENV === 'production') {
  // eslint-disable-next-line no-console
  console.log = console.info = console.debug = () => {};
}

// Self-heal: auto-reload when a newer build is deployed (kills stale mobile-Safari cache).
initVersionGuard();

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Fade out the instant pre-React splash (public/index.html #slik-splash) once React has mounted.
const splashEl = document.getElementById('slik-splash');
if (splashEl) {
  requestAnimationFrame(() =>
    requestAnimationFrame(() => {
      splashEl.style.opacity = '0';
      setTimeout(() => splashEl.remove(), 550);
    })
  );
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
